import React, { useState, useEffect } from "react"
import { onAuthStateChanged } from "firebase/auth"
import { doc, getDoc } from "firebase/firestore"

import { auth, firestore } from "../../../lib/firebase/client"
import { AuthContext } from "./context"

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [status, setStatus] = useState("authenticating")
  const [group, setGroup] = useState()

  useEffect(() => {
    if (!auth) return

    const unsubscribe = onAuthStateChanged(auth, async user => {
      if (!user) {
        setUser(null)
        setStatus("unauthenticated")
        return
      }

      try {
        setUser(user)
        setStatus("authenticated")

        // Define the user group
        if (!group && firestore) {
          const userDocRef = doc(firestore, `users/${user.uid}`)
          const userDoc = await getDoc(userDocRef)

          if (userDoc.exists()) {
            const userData = userDoc.data()
            if (userData.group?.path) {
              const groupDocRef = doc(firestore, userData.group.path)
              const groupDoc = await getDoc(groupDocRef)

              if (groupDoc.exists()) {
                setGroup(groupDoc.data())
              }
            }
          }
        }
      } catch (err) {
        console.error("Error in auth state change:", err)
        setStatus("unauthenticated")
      }
    })

    return unsubscribe
  }, [group])

  return (
    <AuthContext.Provider value={{ user, status, group }}>
      {children}
    </AuthContext.Provider>
  )
}
